/* Component Root Styles
---------------------------------------- */
:host {
  display: block;
  background: #eeeff4;
  padding: 1.5em 1em;
  font-family: var(--font-family);
  font-size: var(--font-size);
  color: var(--color-fg-default);
  line-height: 1.4;
  box-sizing: border-box;
}

/* Container Layout
---------------------------------------- */
.feedback-container {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 0.5em;
  width: 100%;
  max-width: 1080px;
  margin: 0 auto;
}

@media (max-width: 26em) {
  .feedback-container {
    justify-content: center;
  }
}

/* Typography
---------------------------------------- */
h2 {
  display: inline-block;
  margin: 0 0.5em 0 0;
  font-family: var(--font-sans-serif);
  font-size: 1em;
  font-weight: 600;
}

p {
  margin: 0;
  padding: calc(0.5em + 1px) 0;
}

strong {
  font-weight: 600;
}

/* Links
---------------------------------------- */
a {
  color: var(--color-fg-accent);
  text-decoration: underline;
  text-underline-offset: var(--link-text-underline-offset);
  text-decoration-thickness: var(--link-text-decoration-thickness);
}

/* Buttons
---------------------------------------- */
button {
  all: unset;
  display: flex;
  align-items: center;
  gap: 0.5em;
  padding: 0.5em 1.5em;
  font-family: var(--font-family);
  font-weight: 500;
  line-height: 1.4;
  color: var(--color-fg-default);
  background: var(--color-bg-default);
  border: solid 1px var(--color-fg-subtle);
  border-radius: 1em;
  box-sizing: border-box;
}

button:hover {
  cursor: pointer;
}

button:hover span {
  text-decoration: underline;
}

/* Focus States
---------------------------------------- */
*:focus {
  outline: 0;
  box-shadow: 
    0 0 0 2px var(--color-bg-attention),
    0 0 0 3px var(--color-bg-emphasis);
}

p:focus {
  outline: none;
  box-shadow: 0 0 0 2px var(--color-bg-attention), 0 0 0 3px var(--color-bg-emphasis);
}

/* Responsive Adjustments
---------------------------------------- */
@media (max-width: 26em) {
  h2 {
    display: block;
    width: 100%;
    text-align: center;
  }
}

.help-us {
  display: flex;
  flex-direction: column;
  gap: 0.5em;
}

/* Accessibility Helpers
---------------------------------------- */
.visually-hidden {
  clip: rect(0 0 0 0);
  clip-path: inset(50%);
  height: 1px;
  overflow: hidden;
  position: absolute;
  white-space: nowrap;
  width: 1px;
}

/* This ensures the element remains hidden even when focused */
.visually-hidden:focus,
.visually-hidden:active {
  clip: auto;
  clip-path: none;
  height: auto;
  overflow: visible;
  position: static;
  white-space: normal;
  width: auto;
}